import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

export const BannerSkeleton = () => (
    <FormItemSkeleton labelWidth={67}>
        <SkeletonItem width={360} height={150}/>
    </FormItemSkeleton>
);
